// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"76373ec4","705":"5f91734f","911":"69d5f696","991":"1f99e5b5"}[chunkId] + ".chunk.css";
};